<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="mb-5 text-center">{{ staticdata.desa }}</h1>
          <v-row>
            <v-col cols="12" md="6">
              <div style="width: 100%; height: 400px;" class="mb-3">
                <l-map
                  v-if="showMap"
                  :zoom="zoom"
                  :center="center"
                  :options="mapOptions"
                  style="height: 100%"
                  @update:center="centerUpdate"
                  @update:zoom="zoomUpdate">
                  <l-tile-layer
                    :url="url"/>
                  <l-marker :lat-lng="withPopup" :icon="icon">
                    <l-popup>
                      <div @click="innerClick">
                        <strong>{{ staticdata.desa }}</strong>
                        <p v-show="showParagraph">
                          {{ kontak.alamat }}
                        </p>
                        <p>
                          <a :href="gmapurl + '/?api=1&query=' + kontak.lat + ',' + kontak.long" target="_blank">
                            Get Direction
                          </a>
                        </p>
                      </div>
                    </l-popup>
                  </l-marker>
                </l-map>
              </div>
              <div class="text-right">
                <v-btn
                  :href="gmapurl + '/?api=1&query=' + kontak.lat + ',' + kontak.long"
                  color="error"
                  class="mx-0"
                  target="_blank">
                  <v-icon left dark>pin_drop</v-icon>
                  Petunjuk Jalan
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <v-card
                class="mb-5"
                :color="maincolor"
                dark>
                <v-card-title class="title py-3">Alamat</v-card-title>
                <v-card-text class="white text--primary py-3">
                  <p>{{ kontak.alamat }}</p>
                </v-card-text>
              </v-card>
              <v-card
                :color="maincolor"
                class="mb-5"
                dark>
                <v-card-title class="title py-3">Komunikasi</v-card-title>
                <v-card-text class="white text--primary py-3">
                  <div>
                    <v-chip
                      class="ma-2 ml-0"
                      color="primary"
                      label
                      href="#">
                      <v-icon left>contact_mail</v-icon>
                      {{ kontak.email }}
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="pink"
                      label
                      text-color="white"
                      href="#">
                      <v-icon left>contact_phone</v-icon>
                      {{ kontak.phone }}
                    </v-chip>
                    <v-chip
                      class="ma-2"
                      color="cyan"
                      label
                      text-color="white"
                      href="#">
                      <v-icon left>chat</v-icon>
                      {{ kontak.wa }}
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import L from 'leaflet';
import { latLng } from 'leaflet';
import { LMap, LIcon, LTileLayer, LMarker, LPopup, LTooltip } from 'vue2-leaflet';
import { mapState } from 'vuex';

export default {
  name: 'Contact',
  data: () => ({
    word: 'Vue',
    maincolor: process.env.VUE_APP_MAINCOLOR,
    prefix: process.env.VUE_APP_PREFIX,
    panduan: null,
    btnContact: null,
    zoom: 17,
    center: null,
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    withPopup: null,
    currentZoom: 11.5,
    currentCenter: null,
    showParagraph: true,
    mapOptions: {
      zoomSnap: 0.5,
    },
    icon: null,
    showMap: false,
    gmapurl: 'https://www.google.com/maps/search',
    kontak: {
      alamat: '',
      email: '-',
      phone: '-',
      wa: '-',
      long: 0,
      lat: 0,
    },
  }),
  created() {
    // setTimeout(this.initMap(), 1000);
  },
  computed: {
    ...mapState([
      'isAuth',
      'staticdata',
    ]),
  },
  mounted() {
    setTimeout(this.initMap(), 1500);
    // icon
    this.icon = new L.Icon({
      iconUrl: '/img/icons/' + this.prefix + '/android-icon-96x96.png',
      iconAnchor: new L.Point(20, 20),
      iconSize: [40, 40],
    });
    // map
    this.center = latLng(parseFloat(this.staticdata.latitude), parseFloat(this.staticdata.longitude));
    this.withPopup = latLng(parseFloat(this.staticdata.latitude), parseFloat(this.staticdata.longitude));
    this.currentCenter = latLng(parseFloat(this.staticdata.latitude), parseFloat(this.staticdata.longitude));
    this.kontak.long = parseFloat(this.staticdata.longitude);
    this.kontak.lat = parseFloat(this.staticdata.latitude);
    // kontak
    this.kontak.alamat = this.staticdata.alamat;
    this.kontak.email = this.staticdata.email;
    this.kontak.phone = this.staticdata.phone;
    this.kontak.wa = this.staticdata.wa;
  },
  methods: {
    initMap() {
      this.showMap = true;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    innerClick() {
      alert('Click!');
    },
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LIcon,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
